<template>
  <div>
    <div class="carTop">
      <van-sticky>
        <van-nav-bar title="购物车" right-text="删除" @click-right="delCart()" />
      </van-sticky>
    </div>
    <!-- 购物车列表 -->
    <van-checkbox-group v-model="result" ref="checkboxGroup" @change='getchange' v-if="carList.length !=0">
      <div v-for="(item, index) in carList" :key="index" class="cartItem">
        <van-checkbox :name="item.id" checked-color="#FF6A19" ref="checkboxes"></van-checkbox>
        <div class="goodsDiv">
          <img :src="item.image" alt class="goodsImg leftEl" />
          <div class="leftEl checkRight">
            <div class="goodsName">{{item.name}}</div>
            <span
              style="display:inline-block;font-size: 12px;margin-top:10px;background:#f5f5f5;border-radius: 5px;color:#999;padding:4px 5px;">{{item.attribute}}</span>
            <div class="priceNum">
              <span>￥{{item.rank_price}}</span>
              <van-stepper v-model="item.number" class="rightEl" @plus="add(item.id,item)"
                @minus="reduce(item.id,item)" />
            </div>
          </div>
        </div>
      </div>
    </van-checkbox-group>
    <div class="noGoods" v-else>
      <img src="../../assets/imgs/home/noCar.png" alt="" style="display:block;margin:0 auto;width:152px;height:165px;">
      <p>购物车空空如也~</p>
      <van-button type="primary" round @click="$router.push({path:'home'})">去逛逛</van-button>
    </div>

    <!-- 结算 -->
    <div class="payBtm">
      <van-checkbox v-model="checkedAll" @click="checkAll" v-if="isAll" checked-color="#FF6A19">全选</van-checkbox>
      <div class="rightEl">
        <span>
          合计:
          <span class="totalPrice">￥{{ totalPrice }}</span>
        </span>
        <button @click="goPay">结算</button>
      </div>
    </div>
  </div>
</template>
<script>
  import { Dialog, Checkbox, CheckboxGroup } from "vant";
  import { cartList, deleteCart } from "@/api/home";
  export default {
    data() {
      return {
        isAll: true,
        carList: [],
        data: [],
        nums: "",
        znums: "",
        form: {
          page: 1,
          size: 10000
        },
        result: [],
        checkedAll: false,
        value: 1,
        goodsList: [],
        userPid: "",
        adress: []
      };
    },
    computed: {

      totalPrice() {
        let totalPrice = 0;
        let checkedItems = this.carList.filter(item => {
          if (
            this.result.some(c => {
              return c == item.id;
            })
          ) {
            return item;
          }
        });
        checkedItems.forEach(item => {
          totalPrice += Number(item.rank_price) * Number(item.number);
        });
        totalPrice = Number(parseFloat(totalPrice).toFixed(2));
        if (checkedItems.length > 0) {
          return isNaN(totalPrice) ? 0 : totalPrice + this.carList[0].freight;
        } else {
          return 0;
        }
        // return nums;
      }
    },
    created() {
      //  userAddressList().then(res => {
      //    this.adress = res[0];
      //  });
      this.getList();
    },
    methods: {
      getchange(value) {
      },
      getList() {
        cartList().then(res => {
          this.carList = res;
        });
      },
      goPay() {
        this.data = []
        let checkedItems = this.carList.filter(item => {
          if (
            this.result.some(c => {
              return c == item.id;
            })
          ) {
            return item;
          }
        });
        checkedItems.forEach(item => {
          this.data.push({ 'id': item.id, "name": item.name, "image": item.image, "rank_price": item.rank_price, "goods_id": item.goods_id, 'goods_attribute': item.goods_attribute, "number": item.number })
        });
        if (this.data.length == 0) {
          this.$toast('请选择要下单的商品')
          return false;
        } else {
          let jsondata = {
            cart_info: JSON.stringify(this.data),
            totalPrice: this.totalPrice,
          }
          this.$router.push({ name: 'carOrder', query: { data: JSON.stringify(jsondata) } })
          // shoppingPay(jsondata).then(res=>{
          // 		  this.getList();
          // })
        }
        // console.log(this.znums)
        // let datar=[]
        // this.result.map((i,x)=>{
        //  console.log(i)
        // })
        // datar.push({'shop_id':this.result.join(','),'count':this.znums,'address_id':1})
        // data.push({'count':this.znums})
        // data.push({'address_id':1})
        // "shop_id":this.result.join(','),
        // "count":this.znums,
        // "address_id":1,
        // }

        // let checkedItems = this.carList.filter(item => {
        //   if (
        //     this.result.some(c => {
        //       return c == item.id;
        //     })
        //   ) {
        //     return this.goodsList.push(item);
        //   }
        // });

        // if (this.result.length > 0) {
        //   let obj = {
        //     goodsInfo: this.goodsList,
        //     productId: this.result.join(",")
        //   };
        //   let good = JSON.stringify(obj);
        //   localStorage.setItem("temp2", good);
        //   this.$router.push({
        //     path: `carOrder`
        //   });
        // } else {
        //   this.$toast("请选择商品!");
        // }
      },
      // 全选
      checkAll() {
        if (this.checkedAll) {
          this.$refs.checkboxGroup.toggleAll(true);
        } else {
          this.$refs.checkboxGroup.toggleAll(false);
        }
      },
      goDetails(id) {
        localStorage.setItem("goodsId", id);
        this.$router.push({ path: "goodsDetails", query: { id: id } });
      },
      //商品数量增加
      add(id, data) {
        // addCount({ id: id, type: 1 }).then(resp => {
        //   this.$toast.clear();
        data.nums++;
        // this.getDate();
        // });
      },
      //商品数量减少
      reduce(id, data) {
        // this.$toast.loading("处理中...");
        // addCount({ id: id, type: 2 }).then(resp => {
        //   this.$toast.clear();
        data.nums--;
        // this.getDate();
        // });
      },

      // 删除
      delCart() {
        let checkedItems = this.carList.filter(item => {
          if (
            this.result.some(c => {
              return c == item.id;
            })
          ) {
            return item;
          }
        });
        if (this.result) {
          Dialog.confirm({
            message: "确认将这个商品删除？"
          })
            .then(() => {
              deleteCart({ ids: this.result.join(",") }).then(res => {
                this.$toast("删除成功!");
                this.getList();
              });
            })
            .catch(() => {
              this.$toast("取消操作");
            });
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .carTop {
    width: 100%;
    height: 150.5px;
    background: url('../../assets/imgs/home/topBg.png') 0 0 no-repeat;
    background-size: 100% 100%;

    .van-nav-bar {
      background: transparent;
    }
  }

  [class*=van-hairline]::after {
    border: 0 none;
  }

  .van-checkbox-group {
    background: #fff;
    box-sizing: border-box;
    width: 351px;
    border-radius: 10px;
    padding: 16px 11.5px 0;
    overflow: hidden;
    margin: 0 auto;
    margin-top: -100px;
    margin-bottom: 100px;

    .van-checkbox {
      display: inline-block;
      vertical-align: top;
      margin-top: 52px;
    }

    .goodsDiv {
      display: inline-block;
      width: 90%;
      margin-left: 5px;
    }
  }

  .cartItem {
    margin-bottom: 18.5px;
    font-size: 12px;
    color: #666;
    overflow: hidden;
  }

  .goodsImg {
    width: 120px;
    height: 87px;
    margin: 3% 12px 0 0;
    border-radius: 5px;
  }

  .checkRight {
    width: 55%;
    padding-top: 0.3rem;

    .goodsName {
      color: #151d28;
      font-size: 14px;
    }

    .priceNum {
      margin-top: 31px;
    }

    .van-stepper {
      margin-top: -5px;
    }

    /deep/ .van-stepper__minus,
    /deep/ .van-stepper__plus {
      // color: #de4f53;
      width: 0.5rem;
      height: 23px;
      // background-color: transparent;
    }

    /deep/ .van-stepper__input {
      height: 23px;
    }
  }

  /deep/ .van-checkbox__label {
    width: 100%;
  }

  .van-image {
    width: 100%;
    height: 142px;
    border-radius: 6px 6px 0 0;
  }

  .hotWrap {
    width: 100%;
    box-sizing: border-box;
    padding: 0 14.5px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 100px;

    .listItem {
      margin-bottom: 10px;
      box-sizing: border-box;
      width: 48%;
      border-radius: 6px;
      box-shadow: 0 0 4px #ccc;
      font-size: 12px;
      color: #999;

      .itemCon {
        padding: 0 7px 5px 7.5px;
      }

      .goodsName {
        color: #333;
        font-size: 15px;
        margin: 10px 0 14px;
      }

      .goodsPrice {
        .nowPrice {
          color: #de4f53;
          font-size: 15px;
        }

        .oldPrice {
          color: #999;
          text-decoration: line-through;
          margin-left: 10px;
        }
      }

      .goodsBtm {
        margin-top: 19px;

        button {
          margin-left: 6px;
          background: #de4f53;
          width: 85px;
          height: 26px;
          color: #fff;
          border-radius: 13px;
          font-weight: bold;
          line-height: 26px;
          border: 0 none;
          margin-right: 20px;
        }
      }
    }
  }

  .payBtm {
    position: fixed;
    width: 100%;
    background: #fff;
    height: 50px;
    z-index: 1000;
    color: #666666;
    font-size: 15px;

    bottom: 50px;
    left: 0;
    line-height: 50px;
    padding-right: 30px;
    border-top: 1px solid #f6f6f6;

    .van-checkbox {
      float: left;
      margin-left: 20px;
      margin-top: 10px;
    }

    .totalPrice {
      color: #008FFF;
    }

    button {
      width: 70px;
      background: #008FFF;
      color: #fff;
      height: 31px;
      line-height: 31px;
      border: 0 none;
      margin-left: 10px;
      border-radius: 20px;
      margin-right: 25px;
    }
  }

  .delIcon {
    margin-top: -20px;
    color: #de4f53;
  }

  .noGoods {
    img {
      width: 40%;
      display: block;
      margin: 0 auto;
    }

    p {
      font-size: 18px;
      font-weight: 500;
      text-align: center;
    }

    .van-button--normal {
      background-color: transparent;
      border: 1px solid #008FFF;
      color: #008FFF;
      display: block;
      margin: 40px auto 0;
      padding: 0 40px;
      height: 35px;
      line-height: 35px;
    }
  }
</style>